import { render, staticRenderFns } from "./Component-VideoMonitor.vue?vue&type=template&id=b124f3de&scoped=true"
import script from "./Component-VideoMonitor.vue?vue&type=script&lang=js"
export * from "./Component-VideoMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b124f3de",
  null
  
)

export default component.exports